<div *ngIf="severity && customSeverities" class="ds-severity-cell">
  <ds-icon class="margin-right-xs {{ severityClass }}" [icon]="severityIcon" [iconStyle]="IconStyles.Solid"></ds-icon>
  <span class="content .severity">{{ severityText }}</span>
</div>
